document.addEventListener('DOMContentLoaded', function () {
    var customPage = document.getElementById('custom_page')
    var pageContent = document.querySelector('#content[class*="page-cms"]')
    if (customPage) {
        try {
            var pageHeader = document.getElementsByClassName('page-header')[0]
            if (pageHeader) pageHeader.style.display = 'none'
            var navigationBar = document.getElementsByClassName('navigation-bar')[0]
            if (navigationBar) navigationBar.style.display = 'none'
            var content = document.getElementById('content')
            content.classList.add('custom_page-style-reset')
            var promoButtons = content.querySelectorAll('.showPromoCodeBtn')
            var promoCodes = content.querySelectorAll('.showPromoCodeBtn + p')
            if (promoCodes) {
                for (var x = 0; x <= promoCodes.length - 1; x++) {
                    var promoCode = promoCodes[x]
                    if (promoCode.childNodes[0].className === 'promoCode') promoCode.style.display = 'none'
                }
            }
            if (promoButtons.length > 0) {
                for (var i = 0; i <= promoButtons.length - 1; i++) {
                    var promoButton = promoButtons[i]
                    promoButton.addEventListener('click', function () {
                        var promoCodeEl = this.parentNode.querySelector('.showPromoCodeBtn + p > .promoCode')
                        if (promoCodeEl) this.textContent = promoCodeEl.textContent
                        else this.textContent = 'Brak kodu'
                    })
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    else if (pageContent && !customPage) {
        var productsList = pageContent.getElementsByClassName('products-list')
        if (productsList) pageContent.classList.add('cms-page-style-reset')
    }
})
